import * as React from 'react';
import strings from 'owa-strings/owa-tasks-strings';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';

const styles = require('./CompleteCheckbox.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CompleteCheckboxProps {
    isComplete: boolean;
    onToggleComplete?: () => any;
}

@observer
export default class CompleteCheckbox extends React.Component<CompleteCheckboxProps, {}> {
    render() {
        const { isComplete } = this.props;
        const title = isComplete ? strings.markAsNotCompleted : strings.markAsCompleted;

        return (
            <IconButton
                className={classNames(styles.checkBox, {
                    completed: isComplete,
                })}
                iconProps={{
                    iconName: ControlIcons.CheckMark,
                    className: styles.checkMarkCircle,
                }}
                aria-label={title}
                onClick={this.onClick}
                title={title}
                checked={isComplete}
                toggle={true}
            />
        );
    }

    private onClick = (evt: React.MouseEvent<EventTarget>) => {
        evt.stopPropagation();
        const onToggleComplete = this.props.onToggleComplete;
        if (onToggleComplete) {
            onToggleComplete();
        }
    };
}
